import { CustomColumnGridConfig } from '../types'
import { Box, Stack } from '@mui/material'
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined'
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined'
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'
import { formatDateTimeCell } from '@/utils/cellFormat'

export const CONSUMPTION_FIELD = 'consumption' as const

const TYPE_ICONS = {
  alert: NotificationsActiveOutlinedIcon,
  notification: SmsOutlinedIcon,
  crmTask: AssignmentOutlinedIcon,
} as const

const columnsConfig: CustomColumnGridConfig[] = [
  {
    flex: 1,
    minWidth: 150,
    field: 'date',
    headerName: 'תאריך',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'date',
    },
    filterable: true,
    format: formatDateTimeCell,
    renderCell: params => params.formattedValue,
  },
  {
    flex: 1,
    minWidth: 130,
    field: 'type',
    headerName: 'סוג',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
    renderCell: params => {
      const Icon =
        TYPE_ICONS[params.row.activityType as keyof typeof TYPE_ICONS]
      return (
        <Stack direction="row" alignItems="center" gap={0.75}>
          {Icon ? <Icon fontSize="small" aria-hidden /> : null}
          {params.value}
        </Stack>
      )
    },
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'meterNumber',
    headerName: 'מספר מד',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'activity',
    headerName: 'פעילות',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'activityDescription',
    headerName: 'תיאור פעילות',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'status',
    headerName: 'סטטוס',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
    renderCell: (params: any) => {
      const statusColors: Record<
        string,
        { background: string; color: string }
      > = {
        פתוח: { background: '#F0FBEA', color: '#4D8B43' },
        בתהליך: { background: '#F0FBEA', color: '#4D8B43' },
        סגור: { background: '#F0FBEA', color: '#4D8B43' },
        בוצע: { background: '#F0FBEA', color: '#4D8B43' },
        '-': { background: '#F0FBEA', color: '#4D8B43' },
      }
      const colors = statusColors[params.value]

      if (!colors) return params.value || '-'

      return (
        <Box
          sx={{
            minWidth: 70,
            px: 1.5,
            py: 0.35,
            borderRadius: '18px',
            backgroundColor: colors.background,
            color: colors.color,
            textAlign: 'center',
            fontFamily: 'Rubik, sans-serif',
            fontSize: '13px',
            lineHeight: 1.2,
          }}
        >
          {params.value}
        </Box>
      )
    },
  },
]

export default columnsConfig
